'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _emailStyleTools = require('helpers/emailStyleTools');

var _basketHelpers = require('helpers/basketHelpers');

var _Pickup = require('./Pickup');

var _Pickup2 = _interopRequireDefault(_Pickup);

var _DropOff = require('./DropOff');

var _DropOff2 = _interopRequireDefault(_DropOff);

var _dateTimeHelper = require('helpers/dateTimeHelper');

var _dateTimeHelper2 = _interopRequireDefault(_dateTimeHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CarInfoPanel(props) {
  var components = props.components,
      option = props.option,
      timeFormat = props.timeFormat,
      selectedTimeFormat = props.selectedTimeFormat,
      t = props.t;

  var styleCarContainer = (0, _emailStyleTools.containerStyles)(components, 'CarContainer');
  var selectedTimeFormatFinal = selectedTimeFormat || timeFormat;
  return _react2.default.createElement(
    'table',
    { style: _emailStyleTools.fullMinimal, 'data-component': 'CarInfoPanel' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, styleCarContainer, _emailStyleTools.padTen) },
          _react2.default.createElement(
            'table',
            { style: _emailStyleTools.fullMinimal, 'data-component': 'CarInfoPanel__Sub' },
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { style: { paddingTop: '0', paddingRight: '10px', paddingBottom: '0', paddingLeft: '0', verticalAlign: 'top', width: '20%' } },
                  _react2.default.createElement(
                    'table',
                    { style: _emailStyleTools.fullMinimal },
                    _react2.default.createElement(
                      'tbody',
                      null,
                      _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                          'td',
                          { style: (0, _extends3.default)({ textAlign: 'center' }, _emailStyleTools.noPad) },
                          _react2.default.createElement('img', { src: 'https://goprivate.wspan.com/Scripts/us/GNG/ImagesGNG/car.png', alt: 'logo', style: { width: '50px', height: '50px' } })
                        )
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'td',
                  { style: { paddingTop: '0', paddingRight: '5px', paddingBottom: '0', paddingLeft: '0', verticalAlign: 'top', width: '40%' } },
                  _react2.default.createElement(_Pickup2.default, {
                    airportCode: (0, _basketHelpers.getCarPickupAirportCode)(option),
                    city: (0, _basketHelpers.getCarPickupCityName)(option),
                    components: components,
                    country: (0, _basketHelpers.getCarPickupCountryName)(option),
                    exactLocation: (0, _basketHelpers.getCarExactLocationPickup)(option),
                    location: (0, _basketHelpers.getCarPickupLocationName)(option),
                    time: _dateTimeHelper2.default.getDate(option.carOption.segment.startDateTime) + ' ' + t('car.at') + ' ' + _dateTimeHelper2.default.getTime(option.carOption.segment.startDateTime),
                    t: t
                  })
                ),
                _react2.default.createElement(
                  'td',
                  { style: { paddingTop: '0', paddingRight: '0', paddingBottom: '0', paddingLeft: '5px', verticalAlign: 'top', width: '40%' } },
                  _react2.default.createElement(_DropOff2.default, {
                    airportCode: (0, _basketHelpers.getCarDropOffAirportCode)(option),
                    city: (0, _basketHelpers.getCarDropOffCityName)(option),
                    components: components,
                    country: (0, _basketHelpers.getCarDropOffCountryName)(option),
                    exactLocation: (0, _basketHelpers.getCarExactLocationDropoff)(option),
                    location: (0, _basketHelpers.getCarDropOffLocationName)(option),
                    time: _dateTimeHelper2.default.getDate(option.carOption.segment.endDateTime) + ' ' + t('car.at') + ' ' + _dateTimeHelper2.default.getTime(option.carOption.segment.endDateTime),
                    t: t
                  })
                )
              )
            )
          )
        )
      )
    )
  );
}

var mstp = function mstp(state) {
  return {
    timeFormat: state.templateApplication.templates.currentTemplate.timeFormat,
    components: state.templateApplication.templates.currentTemplate.components,
    selectedTimeFormat: state.rendering.shopOptions.timeFormat
  };
};

exports.default = (0, _reactRedux.connect)(mstp)(CarInfoPanel);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Car/Email/Active/CarInfoPanel.jsx
// module id = 1497
// module chunks = 0